import classname from "classnames";
import rem from "@/utils/rem";
import Loader from "react-loader-spinner";
import PropTypes from 'prop-types';

const Button = ({
	loading,
	prefix,
	suffix,
	text,
	submit,
	warning,
	ghost,
	border,
	round,
	image,
	full,
	noborder,
	sizing = "default",
	maxWidth,
	minWidth,
	noHover,
	dotted,
	error,
	btnText,
	customeHover,
	style,
	nobackground = false,
	grey,
	addClass,
	selected,
	ascent,
	nohover,
	textWarning,
	warningbackgroundhover,
	...btnProps
}) => {
	const sizingOptions = {
		DEFAULT: "default",
		MEDIUM: "medium",
		MINI: "mini",
	};

	const btnStyles = {
		maxWidth: rem(maxWidth),
		minWidth: rem(minWidth),
	};

	const btnClass = classname(
		addClass,
		{
			"button--custom-hover": customeHover,
			"button--reset": warning,
			"button--full": full,
			"button--ghost": ghost,
			'button--ascent': ascent,
			'button--ascent--selected': ascent && selected,
			"button--rounded": round,
			"button--border": border,
			"button--border--no-hover": border && noHover,
			"button--medium": sizing === sizingOptions.MEDIUM,
			"button--mini": sizing === sizingOptions.MINI,
			"button--no-border": noborder,
			"button--dotted-border": dotted,
			"button--error": error,
			"button--text": btnText,
			'button--nobg': nobackground,
			'button--grey': grey,
			'button--no-hover': nohover,
			'button--text-warning': textWarning,
			'button--warning-background-hover' : warningbackgroundhover
		}
	)

	const Prefix = () => {
		if (prefix) {
			return (
				<>
					{prefix}
					<span style={{ marginLeft: rem(8) }}></span>
				</>
			);
		}
		return "";
	};

	const Suffix = () => {
		if (suffix) {
			return (
				<>
					<span style={{ marginLeft: rem(8) }}></span>
					{suffix}
				</>
			);
		}
		return "";
	};

	return (
		<button
			{...btnProps}
			className={btnClass}
			style={btnStyles}
			onClick={submit ? submit : null}
		>
			{loading ? (
				<Loader
					type="ThreeDots"
					color="#ffffff"
					height={10}
					width={15}
				/>
			) : (
				<>
					<Prefix />
					{text}
					<Suffix />
				</>
			)}
		</button>
	);
};

Button.propTypes = {
	nohover: PropTypes.bool,
	textWarning: PropTypes.bool,
	warningbackgroundhover: PropTypes.bool
};

export default Button;
